import React, { useState, useEffect } from 'react';
import { useI18n } from '../../hooks/useI18n';

const CloseIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="18" y1="6" x2="6" y2="18"></line>
    <line x1="6" y1="6" x2="18" y2="18"></line>
  </svg>
);

export const WelcomeCouponBanner: React.FC<{ 
  className?: string;
}> = ({ className = '' }) => {
  const { t } = useI18n();
  const [isDismissed, setIsDismissed] = useState(false);
  const [isPWA, setIsPWA] = useState(false);

  useEffect(() => {
    const checkPWA = () => {
      const match = window.matchMedia('(display-mode: standalone)').matches;
      const navStandalone = ('standalone' in navigator) && (navigator as any).standalone;
      const localInstalled = localStorage.getItem('pwa_installed') === 'true';
      setIsPWA(match || navStandalone || localInstalled);
    };
    checkPWA();

    window.matchMedia('(display-mode: standalone)').addEventListener('change', checkPWA);

    return () => {
      window.matchMedia('(display-mode: standalone)').removeEventListener('change', checkPWA);
    };
  }, []);

  useEffect(() => {
    if (localStorage.getItem('welcome_coupon_dismissed') === 'true') {
      setIsDismissed(true);
    }
  }, []);

  const handleDismiss = () => {
    setIsDismissed(true);
    localStorage.setItem('welcome_coupon_dismissed', 'true');
  };

  // If not PWA or already dismissed, hide entirely
  if (!isPWA || isDismissed) {
    return null;
  }

  return (
    <div className={`pwa-banner-container ${className}`}>
      <div className="pwa-banner">
        <div className="pwa-text-content">
          <div className="pwa-title" dangerouslySetInnerHTML={{ __html: t('pwa_welcome_coupon') }}></div>
        </div>
        <button className="pwa-close" onClick={handleDismiss}>
          <CloseIcon />
        </button>
      </div>

      <style>{`
        .pwa-banner-container {
          position: relative;
          z-index: 10;
        }
        .pwa-banner {
          background: #E6D6FA;
          border-radius: 24px;
          padding: 16px 20px;
          margin-bottom: 24px;
          display: flex;
          align-items: center;
          gap: 16px;
          position: relative;
          z-index: 51;
        }
        .pwa-text-content {
          flex-grow: 1;
          padding-right: 24px;
        }
        .pwa-title {
          color: var(--cab-violet);
          font-weight: 500;
          font-size: 15px;
          line-height: 1.4;
          margin-bottom: 0;
        }
        .pwa-title b {
          font-weight: 700;
        }
        .pwa-close {
          background: none;
          border: none;
          color: var(--cab-note);
          cursor: pointer;
          padding: 4px;
          position: absolute;
          top: 16px;
          right: 16px;
        }

        @media (min-width: 1024px) {
          .pwa-banner {
            align-items: center;
          }
          .pwa-text-content {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            gap: 4px;
          }
          .pwa-title {
            margin-bottom: 0;
            width: 100%;
          }
        }
        @media (max-width: 1023px) {
          .pwa-banner-container.mobile-pt {
            padding-top: 16px;
          }
          .hide-on-mobile {
            display: none !important;
          }
        }
      `}</style>
    </div>
  );
};
